import { DataTableProjection, ProjectionKind } from 'generated/resources/datatable.graphql'

import useProjections from 'modules/core/components/DataTable/hooks/useProjections'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

// NOTE: This calculation is a bit expensive! It's memoized and only done once
export default function useSplittedProjections<T, S extends string>() {
  const { projections, initialProjections } = useProjections<T, S>()
  return useLazyRef(() => {
    const startFixedItems: DataTableProjection<T, S>[] = []
    const shownProjections: DataTableProjection<T, S>[] = []
    const hiddenProjections: DataTableProjection<T, S>[] = []
    const endFixedItems: DataTableProjection<T, S>[] = []

    let startHasPassed = false

    projections.forEach((projection) => {
      const isFixed = projection.fixed
      const isDecorative = projection.kind === ProjectionKind.Decorative
      if (isFixed || isDecorative) {
        return
      }

      shownProjections.push(projection)
    })

    initialProjections.forEach((projection) => {
      const isFixed = projection.fixed
      const isDecorative = projection.kind === ProjectionKind.Decorative
      if (isFixed || isDecorative) {
        if (startHasPassed) {
          endFixedItems.push(projection)
        } else {
          startFixedItems.push(projection)
        }
        return
      }

      startHasPassed = true
      if (
        !shownProjections.some(
          (activeProjection) => activeProjection.identifier === projection.identifier
        )
      ) {
        hiddenProjections.push(projection)
      }
    })

    return [startFixedItems, shownProjections, hiddenProjections, endFixedItems]
  }).current as [
    DataTableProjection<T, S>[],
    DataTableProjection<T, S>[],
    DataTableProjection<T, S>[],
    DataTableProjection<T, S>[],
  ]
}
